/**
 * A default value counts only when it is a non-empty string — the same reading
 * the replaced `!sf.defaultValue` had, so an empty string keeps meaning "no
 * value" and does not silently become a hideable subfield.
 */
var hasDefaultValue = function (subfield) {
    return typeof subfield.defaultValue === 'string' && subfield.defaultValue.length > 0;
};
/** What the editor should show for one subfield row's "Skryté" property. */
export var resolveHiddenState = function (subfield) {
    var withValue = hasDefaultValue(subfield);
    if (subfield.hidden) {
        return withValue
            ? { kind: 'fixedValue', value: subfield.defaultValue }
            : { kind: 'outsideForm' };
    }
    if (withValue)
        return { kind: 'hideable' };
    return subfield.hidden === false ? { kind: 'restorable' } : { kind: 'lockedNoValue' };
};
/** True where the "Skryté" checkbox may be operated. */
export var isHiddenEditable = function (state) {
    return state.kind !== 'lockedNoValue';
};
/**
 * The explanatory line under the checkbox, or `null` where the row says nothing
 * beyond the checkbox itself.
 *
 * `hideable` and `restorable` render nothing: the first is the ordinary case and
 * the second is a state the admin has just produced on purpose, so neither needs
 * a caption. `lockedNoValue` keeps CZNA-246's existing explanation of why the
 * box is disabled.
 */
export var hiddenStateMessageId = function (state) {
    switch (state.kind) {
        case 'fixedValue':
            return 'ui-czna-authorities.settings.forms.visual.property.hidden.state.fixedValue';
        case 'outsideForm':
            return 'ui-czna-authorities.settings.forms.visual.property.hidden.state.outsideForm';
        case 'lockedNoValue':
            return 'ui-czna-authorities.settings.forms.visual.property.hidden.requiresDefaultValue';
        default:
            return null;
    }
};
/**
 * Whether "Výchozí viditelnost" is inert for this subfield.
 *
 * It is, whenever the subfield is hidden, and this is scope point 3 of the
 * ticket: the two properties look like independent siblings in the editor but
 * are not. `DynamicFieldPanel` filters `!sf.hidden` FIRST and only then splits
 * the survivors on `defaultVisible`, so `defaultVisible` on a hidden subfield
 * decides nothing at all. Showing it as a live control is the same failure as
 * the help text — a screen that answers confidently and wrongly.
 */
export var isDefaultVisibleInert = function (state) {
    return state.kind === 'fixedValue' || state.kind === 'outsideForm';
};
